import { Subject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
export class PopoverRef {
    constructor(overlayRef, positionStrategy, config) {
        this.overlayRef = overlayRef;
        this.positionStrategy = positionStrategy;
        this.config = config;
        this.afterClosedSubject = new Subject();
        const { disableClose, hasBackdrop } = config;
        if (!disableClose) {
            const backdropClick$ = this.overlayRef.backdropClick();
            const outsideClick$ = this.overlayRef.outsidePointerEvents().pipe(tap((e) => e.stopPropagation()));
            const closeEvent$ = hasBackdrop ? backdropClick$ : outsideClick$;
            closeEvent$.subscribe(() => this.close());
            this.overlayRef
                .keydownEvents()
                .pipe(filter((event) => event.key === 'Escape'))
                .subscribe((event) => {
                this.close();
                if (config.stopEventOnEsc) {
                    event.stopPropagation();
                }
            });
        }
    }
    close(dialogResult) {
        this.afterClosedSubject.next(dialogResult);
        this.afterClosedSubject.complete();
        this.overlayRef.dispose();
    }
    afterClosed() {
        return this.afterClosedSubject.asObservable();
    }
    positionChanges() {
        return this.positionStrategy.positionChanges;
    }
}
